module.exports = __webpack_public_path__ + "img/banner1.b662142c.jpg";